<template>
  <div id="slide-4" class="slide">
    <img src="../assets/images/tube-line.svg" alt="tube-line" class="line-img tube-line">
    <img src="../assets/images/mobile-line-1.svg" alt="mobile-line-1" class="mobile-line-img mobile-line">

    <div class="container slide-content">
      <div class="row">
        <div class="col-md-7 offset-md-1 col-sm-12">
          <h1 class="p-26 is-pink is-bold mb-3">A quick question whilst we’re analysing TFL’s transport data:</h1>
          <p class="p-26 my-3">We’re using data like this from Londoners' everyday lives to shape and improve the services you use. It can help us streamline transport, highlight air pollution hotspots, reduce energy bills and much more.</p>
          <p class="p-26 is-bold my-3">Can you join Talk London, City Hall’s online community where you can have your say on London’s big issues?</p>
          <button class="btn btn-purple" @click="changeSlide(5, $event)">Yes, of course</button>
          <button class="btn btn-gray" @click="changeSlide(6, $event)">No, sorry</button>
        </div>
      </div>
    </div>

    <div class="mob-line-wrap">
      <img src="../assets/images/mobile-line-2.svg" alt="mobile-line-2" class="mobile-line-img mobile-line-2">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },
  methods: {
    changeSlide(i, event) {
      this.$emit('changeSlide', i);
      this.$ga.event('FA - data journey', 'Slide 3', 'Passed');
      this.$ga.event('FA - data journey', 'Can you join Talk London?', event.target.innerHTML);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .is-center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .spinner {
    border: 8px solid rgba($pink, 0.2);
    border-left: 8px solid $pink;
    animation: spin 1s infinite linear;
    height: 40px;
    width: 40px;
    border-radius: 50%;
  }

  .btn-purple,
  .btn-gray {
    padding: 12px 45px;
    margin-top: 30px;
  }

  .btn-gray {
    margin-left: 30px;
  }

  .tube-line {
    position: absolute;
    right: 0;
    top: 100px;
    transform: scaleY(-1);
  }

  .mobile-line {
    position: absolute;
    top: -70px;
    left: 0px;
    transform: scaleX(-1);
  }

  .mob-line-wrap {
    display: none;
  }

  .mobile-line-2 {
    position: absolute;
    right: 0;
  }

  @media screen and (max-width: 1200px) {
    .slide-content {
      margin-top: 14%;
    }
  }

  @media screen and (max-width: 992px) {
    .tube-line {
      right: -120px;
      top: 100px;
    }
  }

  @media screen and (max-width: 767px) {
    .slide-content {
      margin-top: 90px;
    }

    .mob-line-wrap {
      position: relative;
      margin-top: 60px;
      height: 180px;
      transform: scaleX(-1);
      display: block;
    }

    .p-26 {
      font-size: 20px;
      margin-bottom: 20px!important;
    }

    .btn-purple,
    .btn-gray {
      display: block;
      width: 100%;
      margin: 20px 0;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Slide4.vue